const HOTEL = 'STAY';
const ONE_WAY = 'one-way';
const ROUND_TRIP = 'round-trip';
const MULTI_DESTINATION = 'multi-destination';
const CABIN_CLASS = {
    Economy: 'ECO',
    'Premium Economy': 'PEC',
    Business: 'BUS',
    First: 'FST'
};
const FLIGHT_TYPE_CODE = {
    [ONE_WAY]: 'OW',
    [ROUND_TRIP]: 'RT',
    [MULTI_DESTINATION]: 'MD'
};
const FLIGHT_TYPE_INFO = {
    [ROUND_TRIP]: {
        flightType: ROUND_TRIP,
        typeLabel: 'Round-trip'
    },
    [ONE_WAY]: {
        flightType: ONE_WAY,
        typeLabel: 'One-way'
    },
    [MULTI_DESTINATION]: {
        flightType: MULTI_DESTINATION,
        typeLabel: 'Multi-destination'
    }
};
const CABIN_OPTIONS = [
    {
        label: 'Economy',
        value: 'Economy'
    },
    {
        label: 'Premium Economy',
        value: 'Premium Economy'
    },
    {
        label: 'Business',
        value: 'Business'
    },
    {
        label: 'First',
        value: 'First'
    }
];
const FLIGHT_TYPE_OPTIONS = [
    {
        value: ROUND_TRIP,
        label: FLIGHT_TYPE_INFO[ROUND_TRIP].typeLabel
    },
    {
        value: ONE_WAY,
        label: FLIGHT_TYPE_INFO[ONE_WAY].typeLabel
    },
    {
        value: MULTI_DESTINATION,
        label: FLIGHT_TYPE_INFO[MULTI_DESTINATION].typeLabel
    }
];
const FLIGHT_PLACEHOLDERS = {
    ORIGIN: 'Departing from?',
    DESTINATION: 'Going to?',
    PASSENGERS: 'Passengers',
    PASSENGERS_WITH_HOTEL: '1 Passenger, 1 Room',
    CABIN_CLASS: 'Economy',
    SEARCH_BUTTON: 'Find Your Flight'
};
const FLIGHT_LABELS = {
    ADD_HOTEL: 'Add a hotel',
    ADD_CAR: 'Add a car',
    PACKAGE_DEALS: 'Package Deals',
    CABIN_CLASS: 'Cabin Class',
    PASSENGERS: 'Passengers',
    PASSENGERS_WITH_HOTEL: 'Passengers with Hotel',
    BACK_BUTTON: 'List View'
};
const FLIGHT_DEFAULT_VALUES = {
    FLIGHT_TYPE: ROUND_TRIP,
    CABIN_CLASS: 'Economy',
    ADD_HOTEL: false,
    ADD_CAR: false
};
export { CABIN_CLASS, CABIN_OPTIONS, FLIGHT_DEFAULT_VALUES, FLIGHT_LABELS, FLIGHT_PLACEHOLDERS, FLIGHT_TYPE_CODE, FLIGHT_TYPE_INFO, FLIGHT_TYPE_OPTIONS, HOTEL, MULTI_DESTINATION, ONE_WAY, ROUND_TRIP };
